var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('div',{staticClass:"image-container"},[_c('v-img',{staticClass:"image",attrs:{"src":require("../../assets/images/Logo.png")}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }